import { IComponentController } from '@wix/editor-elements-types';

const mapActionsToProps: IComponentController = ({ reportBi }) => ({
  reportBi,
});

export default mapActionsToProps;
